import review1 from '../assests/images/testimony/review1.png';
import review2 from '../assests/images/testimony/review2.jpg';
import review3 from '../assests/images/testimony/review3.png';
import review4 from '../assests/images/testimony/review4.jpg';

const testimonialData = [
    {
        id: 1,
        personName: "Laila",
        profession: "Business",
        img: review1,
        desc: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, eos? consectetur adipisicing elit. Dolore, eum."
    },
    {
        id: 2,
        personName: "Mr John",
        profession: "Job Holder",
        img: review2,
        desc: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, eos? consectetur adipisicing elit. Dolore, eum."
    },
    {
        id: 3,
        personName: "Rubaiya",
        profession: "Doctor",
        img: review3,
        desc: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, eos? consectetur adipisicing elit. Dolore, eum."
    },
    {
        id: 4,
        personName: "Jaison Holder",
        profession: "Entrepreneur",
        img: review4,
        desc: "Lorem ipsum dolor sit amet, Lorem ipsum dolor sit amet consectetur adipisicing elit. Distinctio, eos? consectetur adipisicing elit. Dolore, eum."
    }
]

export default testimonialData;